<template>
  <section class="page-container">
    <template v-if="!isSelectTeam">
      <div class="flex flex-align-center flex-sb-center">
        <div class="total">
          <div
            v-for="(value,i) in statistics"
            :key="i"
            class="item">
            <span class="num">{{value.val}}</span>
            <span>{{value.name}}</span>
          </div>
        </div>
        <v-button
          gray
          @click="handleCreate">Create Team</v-button>
      </div>
    </template>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Team Leader Name, Mobile No., Email"
        @keyEnter="filterData" />
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="handleRow"
      >
        <el-table-column
          v-if="isSelectTeam"
          align="center"
          width="55">
          <template slot-scope="scope">
            <span :class="[scope.row.checked? 'radio-circle-checked': 'radio-circle' ]"></span>
          </template>
        </el-table-column>
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="people-group"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Team Name">
          <template #default="{ row }">
            <span class="break-word">{{row.team_group_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Team Leader">
          <template #default="{ row }">
            <span class="break-word">{{row.name}}</span>
            <p class="liter-text">{{row.email}}</p>
            <p class="liter-text">{{row.mobile}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="No. of Team Memeber">
          <template #default="{ row }">
            <span class="break-word">{{row.member}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getSpecialTeamList} from '@/api/team'
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'

export default {
  name: 'referBonusList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  props:{
    isSelectTeam:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      search: null,
      date: [],
      status: [],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total teams',
          val: 0
        },
      }
    }
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        this.network().getList()
      }
    },
  },
  methods: {
    handleCreate(){
      this.$router.push('/records/team/create')
    },
    handleRow(row){
      const { team_group_id,team_group_name} = row
      // this.setTeamLeaderData(row)
      if(this.isSelectTeam)
      {
        const { index } = row
        this.tableData.map(item => {
          item.checked = false
        })
        this.tableData[index].checked = true
        this.selectRow = index
        this.$emit('update:teamGroupId',team_group_id)
        this.$emit('update:teamGroupName',team_group_name)
        return
      }
      this.$router.push(`/records/team/detail/${team_group_id}`)
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },
    network(){
      return {
        getList: async (otherParams) => {
          let params = {
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            source: this.source,
            ...otherParams
          }
          const { data } = await getSpecialTeamList(params)
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          if(this.isSelectTeam){
            data.data.map((item, index) => {
              item.checked = false
              item.index = index
              return item
            })
          }
          this.tableData = data.data
          this.statistics.total.val = data.total
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.yellow {
        background: #E36209;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.yellow-dark {
      background: #E36209;
    }
    &.red{
      background: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      height: auto!important;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }


}
::v-deep .el-table-column--selection{
  .cell{
    padding-left: 15px!important;
  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
.radio-circle {
  display: inline-block;
  //   box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  border: 1px solid #D5D8DE;
  background: white;
  cursor: pointer;
}
.radio-circle-checked {
  position: relative;
  display: inline-block;
  //   box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background: #409eff;
  &::before {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background: white;
  }
}
</style>
